module.exports = __webpack_public_path__ + "static/img/3.32e414f.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/pintu/3.jpg
// module id = xU0z
// module chunks = 1